const pizzaData = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1595854341625-f33ee10dbf94?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670',
    name: 'Basil & Tomato',
    description: 'Thin crust, Oregano sauce, mozzarella, basil & cut up tomatoes',
    price: 14.99,
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1633040248073-9a31468f7e99?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770',
    name: 'The Healthy Heart',
    description: 'Thick Crust, Original Sauce, Cheese, Corn, Jalapenos, Pepperoni, Red Bell Peppers & Olives',
    price: 19.99,
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1627461985459-51600559fffe?ixlib=rb-1.2.1&raw_url=true&q=80&fm=jpg&crop=entropy&cs=tinysrgb&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2670',
    name: 'Walnut & Peppers',
    description: 'Thick Crust, Original Sauce, Red & Green bell peppers, **Contains: Walnuts',
    price: 12.99,
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1620374645310-f9d97e733268?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770',
    name: 'Sausage + Mushroom',
    description: 'Regular Crust, Oregano sauce, Mozzarella, Mushrooms, sweet mini jalapenos',
    price: 15.99,
  },
  {
    id: 5,
    image: 'https://images.unsplash.com/photo-1620374645466-dc3ff1558148?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80',
    name: 'The Usual',
    description: 'Thin Crust, Original Red Sauce, Cheese, Mini Green Bell Peppers, Italian Sausage, Meat',
    price: 14.99,
  },
  {
    id: 6,
    image: 'https://images.unsplash.com/photo-1620374643809-b69c702d0ed4?ixlib=rb-1.2.1&raw_url=true&q=80&fm=jpg&crop=entropy&cs=tinysrgb&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770',
    name: 'Green Pizza',
    description: 'Thin Crust, Original Sauce, Cheese, Spinach,mushrooms, sweet mini peppers',
    price: 21.99,
  },
];

export default pizzaData;